export function getFileExtension(NameFile) {
  if (NameFile) {
    let fileName = NameFile;
    let extension = fileName.split('.').pop();
    return extension;
  }
  return -1;
}
